import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Image } from "antd";
import React from "react";
import GlobalStoreContext from "../../context/GlobalStoreContext";
import Helper from "../../Helper";
import { WaypointStep } from "../../models/WaypointStep";
import { mapsIcons } from "../Helper/FontAwesomeMapsIcons";
import WaypointStepAttachmentPreviewToolBar from "../Project/ProjectLogistics/LogisticsLegend/MapLocationEdit/Waypoint/waypointStepAttachmentPreviewToolBar";

interface WaypointStepViewProps {
    waypointStep: WaypointStep;
    index: number;
    isLast?: boolean;
    onClick?: (step: WaypointStep) => void;
}

const WaypointStepView: React.FC<WaypointStepViewProps> = ({ waypointStep, index, isLast }) => {
    const context = React.useContext(GlobalStoreContext);
    const focusWaypoint = () => {
        context.setCurrentWaypointStep(waypointStep);
    };
    const blurWaypoint = () => {
        context.setCurrentWaypointStep(null);
    };
    const icon = waypointStep.icon ? mapsIcons[waypointStep.icon] : null;

    return (
        <div
            className="flex flex-row items-stretch gap-3 w-full"
            onMouseEnter={focusWaypoint}
            onMouseLeave={blurWaypoint}
            id={`waypoint-step-${waypointStep.id}`}
        >
            <div className="flex flex-col items-center">
                <div
                    className="flex items-center justify-center w-6 h-6 rounded-full text-white shrink-0"
                    style={{ backgroundColor: waypointStep.color }}
                >
                    {icon ? (
                        <FontAwesomeIcon
                            icon={icon}
                            size="xs"
                            style={{ transform: `rotate(${waypointStep.iconRotate}deg)` }}
                        />
                    ) : (
                        <span className="text-[10px] font-semibold">{index + 1}</span>
                    )}
                </div>
                {!isLast && <div className="w-px flex-1 bg-gray-300 my-1" />}
            </div>

            <div className={Helper.classNames("flex flex-row items-start justify-between gap-2 flex-1 min-w-0", !isLast && "pb-3")}>
                <div className="text-sm text-gray-700 pt-0.5">{waypointStep.instruction}</div>

                {waypointStep.pictureUrl && (
                    <div className="flex flex-row items-center gap-2 h-24 overflow-clip shrink-0">
                        <Image
                            alt="waypoint step image attachment preview"
                            preview={{
                                toolbarRender: (
                                    _: any,
                                    {
                                        transform: { scale },
                                        actions: {
                                            onFlipY,
                                            onFlipX,
                                            onRotateLeft,
                                            onRotateRight,
                                            onZoomOut,
                                            onZoomIn,
                                            onReset,
                                        },
                                    }
                                ) => (
                                    <WaypointStepAttachmentPreviewToolBar
                                        onFlipY={onFlipY}
                                        onFlipX={onFlipX}
                                        onRotateLeft={onRotateLeft}
                                        onRotateRight={onRotateRight}
                                        onZoomOut={onZoomOut}
                                        onZoomIn={onZoomIn}
                                        onReset={onReset}
                                    />
                                ),
                            }}
                            src={waypointStep.pictureUrl}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default WaypointStepView;
